export default __webpack_public_path__ + "images/WaterletHandOutline-Bold.font.e0482d296252b57ecee1e5e12b90620f.svg";